import AccountMainLayout from '../Layout/AccountMainLayout';
import { Link, useLocation } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import ErrorBanner from './ErrorBanner';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { changePassword, updateProfile, overview } from '../utils/endpoint';
import { getApi, postApi } from '../utils/api';
import * as Yup from 'yup';
import { state_city } from '../utils/state_cities';
import { setPersonalDetail } from '../redux/features/signup/signupSlice';
import { ThreeDots } from 'react-loader-spinner';
import { emailRegExp, phoneRegExp } from '../utils/common';
import { AccountAddresses } from './AccountAddresses';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Account from './Account';
import { logoutUser } from '../utils/Storage';

const ProfilePreferences = () => {
  const { personalDetail } = useSelector((state) => state.signup);
  const [formData, setFormData] = useState({
    fullName:
      personalDetail?.fullName || personalDetail?.name
        ? personalDetail?.fullName || personalDetail?.name
        : '',
    // lastName:
    //   personalDetail?.lastName || personalDetail?.last_name
    //     ? personalDetail?.lastName || personalDetail?.last_name
    //     : '',
    email: personalDetail.email ? personalDetail.email : '',
    phoneNumber:
      personalDetail?.phoneNumber || personalDetail?.telephone
        ? personalDetail?.phoneNumber || personalDetail?.telephone
        : '',
    password: personalDetail?.password ? personalDetail?.password : '00000000',
    address: personalDetail?.address ? personalDetail?.address : '',
    address2: personalDetail?.address2 ? personalDetail?.address2 : '',
    state: personalDetail?.state ? personalDetail?.state : '',
    city: personalDetail?.city ? personalDetail?.city : '',
    zipCode: personalDetail?.zipCode
      ? personalDetail?.zipCode
      : personalDetail?.zipcode
        ? personalDetail?.zipcode
        : '',
    isAdditional: false,
    additionalFirstName: '',
    additionalLastName: '',
  });
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  let statelist = Object.keys(state_city);
  // const [fieldErrors, setFieldErrors] = useState({});

  const [showError, setShowError] = useState(false);
  const [showErrorDetail, setShowErrorDetail] = useState({
    isError: true,
    message: '',
  });
  const [isOverviewLoading, setIsOverviewLoading] = useState(true);
  const [overviewData, setOverviewData] = useState({
    plan: {},
    subscription: {},
    upcomingInvoice: {},
  });
  const formRef = useRef(null);
  const access_token = Cookies.get('userToken');
  const [errors, setErrors] = useState('');
  const { state } = useLocation();
  const { dataState } = state || '';

  useEffect(() => {
    if (isOverviewLoading) {
      return;
    }

    const activateTab = (tabButtonId, tabContentId) => {
      const tabEle = document.querySelectorAll('.nav-link');
      const activeElements = document.querySelectorAll('.active');

      activeElements.forEach((element) => {
        element.classList.remove('active', 'show');
      });

      tabEle.forEach((element) => {
        if (element.id === tabButtonId) {
          element.classList.add('active');
          const tabContent = document.getElementById(tabContentId);
          if (tabContent) {
            tabContent.classList.add('active', 'show');
          }
        }
      });
    };

    if (dataState === 'profileAddresses') {
      activateTab('nav-profile-tab', 'nav-profile');
    }

    if (dataState === 'profileOrderHistory') {
      activateTab('nav-order-history-tab', 'nav-order-history');
    }
  }, [dataState, isOverviewLoading]);

  useEffect(() => {
    const fetchMembershipOverview = async () => {
      setIsOverviewLoading(true);
      try {
        const res = await getApi(overview, access_token);

        if (res?.data?.success) {
          setOverviewData({
            plan: res?.data?.data?.plans || {},
            subscription: res?.data?.data?.subscription || {},
            upcomingInvoice: res?.data?.data?.upcomingInvoice || {},
          });
        }
      } catch (err) {
        if (
          err?.response?.status === 401 &&
          err?.response?.statusText === 'Unauthorized'
        ) {
          logoutUser();
          window.location.replace('/');
          return;
        }

        console.log(err);
      } finally {
        setIsOverviewLoading(false);
      }
    };

    fetchMembershipOverview();
  }, [access_token]);

  const handleChangePassword = (e) => {
    e.preventDefault();
    setLoading(true);
    postApi(changePassword, {}, access_token)
      .then((res) => {
        if (res?.data?.success) {
          setShowErrorDetail({
            isError: false,
            message:
              'An email containing a password-reset link has been sent to you.',
          });
          setShowError(true);
          setTimeout(() => {
            setShowError(false);
            setShowErrorDetail({
              isError: true,
              message: '',
            });
          }, 7000);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleClose = () => {
    setShowError(false);
    setShowErrorDetail({
      isError: true,
      message: '',
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    // Validation
    try {
      validationSchema.validateSyncAt(name, { [name]: value });
      setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    } catch (error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error.message,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await validationSchema.validate(formData, {
        abortEarly: false,
      });
      setErrors('');
      // const { city, state } = formData;
      // if (!state_city[state].includes(city)) {
      //   setShowError(true);
      //   setShowErrorDetail({
      //     isError: false,
      //     message: 'Not a valid United States city.',
      //   });
      //   setTimeout(() => {
      //     setShowError(false);
      //     setShowErrorDetail({
      //       isError: true,
      //       message: '',
      //     });
      //   }, 3000);
      //   setIsLoading(false);
      // } else {
      const formdata = new FormData();
      formdata.append('name', formData.fullName);
      // formdata.append('last_name', formData.lastName);
      formdata.append('email', formData.email);
      formdata.append('telephone', formData.phoneNumber);
      // formdata.append('city', formData.city);
      // formdata.append('state', formData.state);
      // formdata.append('zipcode', formData.zipCode);
      // formdata.append('address', formData.address);
      // formdata.append('address2', formData.address2);
      postApi(updateProfile, formdata, access_token)
        .then((res) => {
          if (res?.data?.success) {
            window.scrollTo(0, 0);
            setShowErrorDetail({
              isError: false,
              message: 'Updated!',
            });
            setShowError(true);
            setTimeout(() => {
              setShowError(false);
              setShowErrorDetail({
                isError: true,
                message: '',
              });
            }, 7000);

            localStorage.setItem('userData', JSON.stringify(res?.data?.data));
            dispatch(setPersonalDetail(res?.data?.data));
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
      // }
    } catch (error) {
      const validationErrors = {};
      error.inner.forEach((err) => {
        validationErrors[err.path] = err.message;
      });
      console.log(error);
      if (Object.entries(validationErrors).length === 0) {
        setShowError(true);
        setShowErrorDetail({
          isError: true,
          message: 'Please fill all the required fields.',
        });
        setTimeout(() => {
          setShowError(false);
          setShowErrorDetail({
            isError: true,
            message: '',
          });
        }, 3000);
      }
      setErrors(validationErrors);
      setIsLoading(false);
    }
  };

  const handleManualSubmit = async (e) => {
    e.preventDefault();
    const form = formRef.current;
    if (form.checkValidity()) {
      setIsLoading(true);
      await handleSubmit(e);
    } else {
      setShowError(true);
      setShowErrorDetail({
        isError: true,
        message: 'Please fill all the required fields.',
      });
      setTimeout(() => {
        setShowError(false);
        setShowErrorDetail({
          isError: true,
          message: '',
        });
      }, 3500);
      // const newFieldErrors = {};
      // for (let i = 0; i < form.elements.length; i++) {
      //   const field = form.elements[i];
      //   if (
      //     field.tagName === 'INPUT' ||
      //     field.tagName === 'TEXTAREA' ||
      //     field.tagName === 'SELECT'
      //   ) {
      //     if (!field.validity.valid) {
      //       newFieldErrors[field.name] = true;
      //     }
      //   }
      // }
      // setFieldErrors(newFieldErrors);
      form.reportValidity();
    }
  };
  const styleClass = {
    color: 'red',
  };
  const handleLogout = () => {
    logoutUser();
    window.location.replace('/');
  };

  const activeSubscription =
    overviewData?.subscription || personalDetail?.subscriptions?.[0] || {};
  const activePlan = overviewData?.plan || {};

  const membershipName = activePlan?.plan?.name || activePlan?.name;

  const matchedPackagePrice = Array.isArray(activePlan?.package_prices)
    ? activePlan.package_prices.find(
        (price) => price?.stripe_price_id === activeSubscription?.stripe_price
      )
    : null;

  const planFrequencyRaw =
    matchedPackagePrice?.price_frequency ||
    activePlan?.subscriptionType ||
    activePlan?.subscriptionInterval ||
    '';

  const normalizedPlanFrequency =
    String(planFrequencyRaw).toLowerCase() === 'month' ||
    String(planFrequencyRaw).toLowerCase() === 'monthly'
      ? 'Monthly'
      : String(planFrequencyRaw).toLowerCase() === 'year' ||
          String(planFrequencyRaw).toLowerCase() === 'yearly' ||
          String(planFrequencyRaw).toLowerCase() === 'annual'
        ? 'Yearly'
        : planFrequencyRaw;

  const membershipCardTitle =
    membershipName && normalizedPlanFrequency
      ? `${membershipName} - ${normalizedPlanFrequency}`
      : membershipName || normalizedPlanFrequency || 'Caliber Card';

  const membershipStatus = (
    activeSubscription?.stripe_status ||
    activeSubscription?.status ||
    'active'
  )
    .toLowerCase()
    .trim();

  const normalizedMembershipStatus = membershipStatus
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const membershipBadgeType =
    normalizedMembershipStatus === 'active' ||
    normalizedMembershipStatus === 'trialing'
      ? 'active'
      : normalizedMembershipStatus.includes('pending') ||
          normalizedMembershipStatus.includes('past due') ||
          normalizedMembershipStatus.includes('unpaid')
        ? 'pending'
        : normalizedMembershipStatus.includes('cancel') ||
            normalizedMembershipStatus.includes('ended')
          ? 'canceled'
          : normalizedMembershipStatus.includes('inactive') ||
              normalizedMembershipStatus.includes('in-active')
            ? 'inactive'
            : 'active';

  const membershipBadgeLabel =
    membershipBadgeType === 'active'
      ? 'Active'
      : membershipBadgeType === 'pending'
        ? 'Pending'
        : membershipBadgeType === 'canceled'
          ? 'Canceled'
          : 'Inactive';

  return (
    <>
      <AccountMainLayout>
        <div className="account-login pt-5">
          {isOverviewLoading && (
            <div className="loader">
              <ThreeDots
                height="110"
                width="110"
                radius="10"
                color="#aeaeae"
                ariaLabel="three-dots-loading"
                wrapperStyle={{ display: 'contents' }}
                wrapperClassName=""
                visible={true}
              />
            </div>
          )}
          {!isOverviewLoading && (
            <div className="container-fluid">
              <div className="user-profile-account">
                <div className="profile-name">
                  <div className="profile-image">
                    <i className="fa fa-user-circle-o" aria-hidden="true"></i>
                  </div>
                  <div className="user-name-and-edit">
                    <h2>My Profile</h2>
                    <p>Manage your personal info, addresses and orders.</p>
                  </div>
                </div>
                <div className="log-out-user">
                  <button
                    className="theme-button login-button my-0"
                    onClick={handleLogout}
                  >
                    <img src="../images/logout.svg" alt="" />
                    Log out
                  </button>
                </div>
              </div>
              <nav className="tabs-bills">
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    className="nav-link active"
                    id="nav-home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-home"
                    type="button"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                  >
                    My Profile
                  </button>
                  <button
                    className="nav-link"
                    id="nav-profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-profile"
                    type="button"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                  >
                    Address
                  </button>
                  <button
                    className="nav-link"
                    id="nav-order-history-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-order-history"
                    type="button"
                    role="tab"
                    aria-controls="nav-order-history"
                    aria-selected="false"
                  >
                    Order History
                  </button>
                </div>
              </nav>
              <div className="tab-content" id="nav-tabContent">
                <div
                  className="tab-pane fade show active px-2"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >
                  {showError && (
                    <ErrorBanner
                      error={showErrorDetail}
                      handleClose={handleClose}
                    />
                  )}
                  <form
                    className="user-details account-login"
                    id="earlyAccessForm"
                    ref={formRef}
                  >
                    <div className="row">
                      {/* <div className="link-profile">
                      <ul>
                        <li>
                          <Link>My Profile</Link>
                        </li>
                      </ul>
                    </div> */}
                      <div className="col-lg-8">
                        <div className="row">
                          <div className="profile-heading">
                            <h2>Personal Information</h2>
                          </div>
                          <div className="grid-profile">
                            <ReactTooltip
                              id="fullName"
                              place="top"
                              variant="info"
                              content={errors.fullName}
                            />
                            <div
                              className="floating-group grid-full"
                              data-tooltip-id="fullName"
                            >
                              <input
                                type="text"
                                className={
                                  'form-control input-outline' +
                                  (errors.fullName
                                    ? ' error-input-border-red'
                                    : '')
                                }
                                value={formData.fullName}
                                onChange={handleInputChange}
                                name="fullName"
                                required
                              />
                              <label
                                htmlFor="fullName"
                                className="form-label label-text"
                              >
                                Full Name*
                              </label>
                              {/* {errors.fullName && (
                              <div style={styleClass}>{errors.fullName}</div>
                            )} */}
                            </div>
                            <ReactTooltip
                              id="email"
                              place="top"
                              variant="info"
                              content={errors.email}
                            />
                            <div
                              className="floating-group select-floating"
                              data-tooltip-id="email"
                            >
                              <input
                                type="email"
                                className={
                                  'form-control input-outline' +
                                  (errors.email
                                    ? ' error-input-border-red'
                                    : '')
                                }
                                value={formData.email}
                                onChange={handleInputChange}
                                name="email"
                                readOnly
                                required
                              />
                              <label
                                htmlFor="email"
                                className="form-label label-text"
                              >
                                Email Address
                              </label>
                              {errors.email && (
                                <div style={styleClass}>{errors.email}</div>
                              )}
                            </div>

                            <ReactTooltip
                              id="phoneNumber"
                              place="top"
                              variant="info"
                              content={errors.phoneNumber}
                            />
                            <div
                              className="floating-group"
                              data-tooltip-id="phoneNumber"
                            >
                              <input
                                type="tel"
                                maxLength="10"
                                className={
                                  'form-control input-outline' +
                                  (errors.phoneNumber
                                    ? ' error-input-border-red'
                                    : '')
                                }
                                value={formData.phoneNumber}
                                onChange={handleInputChange}
                                name="phoneNumber"
                                onKeyPress={(e) => {
                                  const regex = /^[0-9\b]+$/;
                                  if (!regex.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                required
                              />
                              <label
                                htmlFor="phoneNumber"
                                className="form-label label-text"
                              >
                                Phone Number*
                              </label>
                              {/* {errors.phoneNumber && (
                              <div style={styleClass}>{errors.phoneNumber}</div>
                            )} */}
                            </div>

                            <div className="save-text-button grid-full">
                              <div className="t-center ">
                                <span>Want to change your password? </span>
                                <Link
                                  type="button"
                                  onClick={
                                    !loading ? handleChangePassword : null
                                  }
                                  className="link-text ps-2"
                                  disabled
                                >
                                  {loading ? <p>Loading...</p> : 'Click here'}
                                </Link>
                              </div>
                              <button
                                className={`theme-button my-0 login-button ${
                                  isLoading ? 'disable' : ''
                                }`}
                                form="earlyAccessForm"
                                onClick={handleManualSubmit}
                              >
                                {isLoading ? (
                                  <div className="d-flex justify-content-center">
                                    <ThreeDots
                                      height="27"
                                      width="49"
                                      radius="2"
                                      color="#fff"
                                      ariaLabel="three-dots-loading"
                                      wrapperStyle={{}}
                                      wrapperClassName=""
                                      visible={true}
                                    />
                                  </div>
                                ) : (
                                  'Save'
                                )}
                              </button>
                            </div>
                          </div>
                          {formData?.isAdditional && (
                            <>
                              <div className="col-md-12">
                                <h2 className="primary-heading">
                                  ADDITIONAL ASSOCIATE
                                </h2>
                              </div>
                              <div className="col-md-6">
                                <label
                                  htmlFor="additionalFirstName"
                                  className="form-label label-text"
                                >
                                  First name*
                                </label>
                                <input
                                  type="text"
                                  className="form-control input-outline"
                                  placeholder="First name*"
                                  value={formData.additionalFirstName}
                                  name="additionalFirstName"
                                  required
                                  onChange={handleInputChange}
                                />
                                {errors.additionalFirstName && (
                                  <div style={styleClass}>
                                    {errors.additionalFirstName}
                                  </div>
                                )}
                              </div>
                              <div className="col-md-6">
                                <label
                                  htmlFor="additionalLastName"
                                  className="form-label label-text"
                                >
                                  Last name*
                                </label>
                                <input
                                  type="text"
                                  className="form-control input-outline"
                                  placeholder="Last name*"
                                  value={formData.additionalLastName}
                                  name="additionalLastName"
                                  required
                                  onChange={handleInputChange}
                                />
                                {errors.additionalLastName && (
                                  <div style={styleClass}>
                                    {errors.additionalLastName}
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                          <div className="col-md-12 d-none">
                            <h2 className="primary-heading">BILLING ADDRESS</h2>
                          </div>
                          <div className="col-md-12 d-none">
                            <label
                              htmlFor="address"
                              className="form-label label-text"
                            >
                              Street Address 1*
                            </label>
                            <input
                              type="address"
                              className="form-control input-outline"
                              placeholder="Street Address 1*"
                              value={formData.address}
                              onChange={handleInputChange}
                              name="address"
                              required
                            />
                            {errors.address && (
                              <div style={styleClass}>{errors.address}</div>
                            )}
                          </div>
                          <div className="col-md-12 d-none">
                            <label
                              htmlFor="address2"
                              className="form-label label-text"
                            >
                              Street Address 2
                            </label>
                            <input
                              type="address"
                              className="form-control input-outline"
                              placeholder="Street Address 2"
                              value={formData.address2}
                              onChange={handleInputChange}
                              name="address2"
                            />
                          </div>
                          <div className="col-md-6 d-none">
                            <label
                              htmlFor="input_State"
                              className="form-label label-text"
                            >
                              State*
                            </label>
                            <select
                              id="input_State"
                              className="form-select input-outline"
                              name="state"
                              value={formData.state}
                              onChange={handleInputChange}
                              required
                            >
                              <option disabled>Select State</option>
                              {statelist.map((item, index) => (
                                <option value={item} key={index}>
                                  {item}
                                </option>
                              ))}
                            </select>
                            {/* <p className="form-membership">
                      We do not offer memberships for those in the following
                      states: New York, New Jersey, Washington
                    </p> */}
                          </div>
                          <div className="col-md-6 d-none">
                            <label
                              htmlFor="inputCity"
                              className="form-label label-text"
                            >
                              City*
                            </label>
                            <input
                              type="text"
                              className="form-control input-outline"
                              id="inputCity"
                              placeholder="City"
                              name="city"
                              onChange={handleInputChange}
                              value={formData.city}
                              required
                            />
                          </div>
                          <div className="col-md-12 d-none">
                            <label
                              htmlFor="inputZip"
                              className="form-label label-text"
                            >
                              Postal/ZIP code*
                            </label>
                            <input
                              type="text"
                              className="form-control input-outline"
                              id="inputZip"
                              placeholder="Postal/ZIP code"
                              name="zipCode"
                              value={formData.zipCode}
                              onChange={handleInputChange}
                              maxLength="5"
                              onKeyPress={(e) => {
                                const regex = /^[0-9\b]+$/;
                                if (!regex.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              required
                            />
                          </div>
                          <div className="text-end mb-5 d-none">
                            <button
                              className={`theme-button login-button ${
                                isLoading ? 'disable' : ''
                              }`}
                              form="earlyAccessForm"
                              onClick={handleManualSubmit}
                            >
                              {isLoading ? (
                                <div className="d-flex justify-content-center">
                                  <ThreeDots
                                    height="30"
                                    width="35"
                                    radius="2"
                                    color="#fff"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClassName=""
                                    visible={true}
                                  />
                                </div>
                              ) : (
                                'Save '
                              )}
                            </button>
                          </div>
                        </div>
                        {/* </form> */}
                      </div>
                      <div className="col-lg-4">
                        <div className="profile-heading">
                          <h2>Membership</h2>
                        </div>
                        <div className="grid-profile">
                          <div className="membership-card-list grid-full">
                            <div className="star-image">
                              <img src="../images/star-new.svg" alt="star" />
                            </div>
                            <div className="card-membership">
                              <h4>{membershipCardTitle}</h4>
                              <span
                                className={`badge-membership badge-${membershipBadgeType}`}
                              >
                                <span
                                  className={`badge-status-${membershipBadgeType}`}
                                ></span>
                                {membershipBadgeLabel}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="profile-heading mt-3">
                          <h2>Security</h2>
                        </div>
                        <div className="grid-profile">
                          <div className="membership-card-list key-card grid-full">
                            <div className="star-image">
                              <img src="../images/key.svg" alt="star" />
                            </div>
                            <div className="card-membership">
                              <h3>Change Password</h3>
                              <p>Update your account password</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-profile"
                  role="tabpanel"
                  aria-labelledby="nav-profile-tab"
                >
                  <AccountAddresses />
                </div>
                <div
                  className="tab-pane fade"
                  id="nav-order-history"
                  role="tabpanel"
                  aria-labelledby="nav-order-history-tab"
                >
                  <Account />
                </div>
              </div>
            </div>
          )}
        </div>
      </AccountMainLayout>
    </>
  );
};

export default ProfilePreferences;

const validationSchema = Yup.object().shape({
  fullName: Yup.string().required('First name is required'),
  // lastName: Yup.string().required('Last name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required')
    .matches(emailRegExp, 'Please enter a valid Email Address'),
  phoneNumber: Yup.string()
    .required('Phone number is required')
    .matches(phoneRegExp, 'Please enter valid mobile number'),
  address: Yup.string().required('Address is required'),
  state: Yup.string().required('State is required'),
});
